import React from "react";
import "./Projects.css";

const Projects = () => {
    const projects= [
        {
            name: "Project Portfolio Website",
            description: "A personal website to showcase my projects, skills and experience.", 
            tech: "React, Bootstrap, React Router", 
            link: "https://github.com/P-Verma101/project-portfolio"
        },
        {
            name: "Fraser Health x WEST MRI Stimulator Project",
            description: "The user interface design for the MRI Stimulator.", 
            tech: "Python, PySide, HTML, CSS", 
            link: "https://github.com/UVic-WEST/uvic-west-fraser-health-MRI-simulator"
        }
        
    ];

    return (
        <div className="projects-container">
        <div className="projects-content">
                {projects.map((project, index) => (
                    <div key={index} className="project-card">
                        <h2><strong>{project.name}</strong></h2>
                        <p>{project.description}</p>
                        <p className="tech"><em>{project.tech}</em></p>
                        {project.link && (
                            <a
                            href={project.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="github-link"
                        >
                            View on GitHub
                        </a>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Projects;